import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SentryErrorBoundary from './components/shared/SentryErrorBoundary';
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ResponsiveNavbar from "./components/navbar/ResponsiveNavbar";
import Home from "./pages/Home";
import AnimePage from "./pages/AnimePage";
import MangaPage from "./pages/MangaPage";
import CharactersPage from './pages/CharactersPage';
import AnimeDetails from "./pages/AnimeDetails";
import MangaDetails from "./pages/MangaDetails";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import VerificationPending from './pages/VerificationPending';
import EmailVerification from './pages/EmailVerification';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Profile from "./pages/Profile";
import AnimeListPage from './pages/AnimeListPage';
import SettingsPage from './pages/SettingsPage';
import PublicProfile from './pages/PublicProfile';
import SearchResults from "./pages/SearchResults";
import CharacterDetails from "./pages/CharacterDetails";
import GenresPage from "./pages/GenresPage";
import GenrePage from "./pages/GenrePage";
import MangaGenresPage from "./pages/MangaGenresPage";
import MangaGenrePage from "./pages/MangaGenrePage";
import AnimeCategoryPage from './pages/AnimeCategoryPage';
import Community from "./pages/Community";
import DevelopmentBanner from "./components/DevelopmentBanner";
import NotFound from './pages/NotFound';
import FAQ from './pages/FAQ';
import SupportPage from "./pages/SupportPage";
import BasicSentryTest from "./BasicSentryTest";

import "./App.css";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 30 * 60 * 1000, // 30 minutes
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <SentryErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider>
          <Router>
            <div className="App">
            {/* <BasicSentryTest /> */}
              <DevelopmentBanner />
              <ResponsiveNavbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/anime/:id" element={<AnimeDetails />} />
                <Route path="/manga/:id" element={<MangaDetails />} />
                <Route path="/anime" element={<AnimePage />} />
                <Route path="/manga" element={<MangaPage />} />
                <Route path="/community" element={<Community />} />
                <Route path="/characters" element={<CharactersPage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/verification-pending" element={<VerificationPending />} />
                <Route path="/verify-email/:token" element={<EmailVerification />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/my-anime-list" element={<AnimeListPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/users/:userId" element={<PublicProfile />} />
                <Route path="/search" element={<SearchResults />} />
                <Route path="/characters/:id" element={<CharacterDetails />} />
                <Route path="/genres" element={<GenresPage />} />
                <Route path="/genres/:genre" element={<GenrePage />} />
                <Route path="/manga/genres" element={<MangaGenresPage />} />
                <Route path="/manga/genres/:genre" element={<MangaGenrePage />} />
                <Route path="/anime/category/:category" element={<AnimeCategoryPage />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/support" element={<SupportPage />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
          </Router>
        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
    </SentryErrorBoundary>
  );
}

export default App;